module.exports = __webpack_public_path__ + "img/PGa.b61289f7.png";